import { createTestIds } from '../../utils';

export const getMenuButtonTestIds = createTestIds('menu-button', [] as const);
